"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// eslint-disable-next-line @typescript-eslint/no-var-requires
var moment = require('moment'); // eslint-disable-next-line @typescript-eslint/no-var-requires


var MapistryDate = require('mapistry-date');

function getAsNeededInspectionsSubmission(templateSlug, year, asNeededNumber) {
  return [templateSlug, year, asNeededNumber].join('-');
}

function nonstandardSwpppSlug(stateIdentifierForSlug) {
  if (stateIdentifierForSlug === 'az') {
    return 'az-industrial-swppp-2020';
  }

  return null;
}

var SlugFactory = {
  /**
   * Generates a slug for SWPPP templates and submissions
   */
  getSwppp: function getSwppp(state, industryType, isFederalProject) {
    var stateIdentifierForSlug = isFederalProject ? 'federal' : state;
    var nonstandardSwppp = nonstandardSwpppSlug(stateIdentifierForSlug);
    return nonstandardSwppp == null ? [stateIdentifierForSlug, industryType, 'swppp'].join('-') : nonstandardSwppp;
  },
  isSwpppSubmissionSlug: function isSwpppSubmissionSlug(slug) {
    return /swppp/.test(slug);
  },
  isVisualAssessmentSubmissionSlug: function isVisualAssessmentSubmissionSlug(slug) {
    return /visual-assessment/.test(slug);
  },
  isRoutineInspectionSubmissionSlug: function isRoutineInspectionSubmissionSlug(slug) {
    return /routine-facility-inspection/.test(slug);
  },
  getVisualAssesmentsSubmission: function getVisualAssesmentsSubmission(projectState, projectIsFederal, year, visualAssessmentNumber) {
    var formTemplateSlug = this.getVisualAssesmentsTemplate(projectState, projectIsFederal);
    return [formTemplateSlug, year, 'visual-assessment', visualAssessmentNumber].join('-');
  },
  getVisualAssesmentsTemplate: function getVisualAssesmentsTemplate(projectState, projectIsFederal) {
    return projectIsFederal ? 'federal-visual-assessment' : "".concat(projectState, "-visual-assessment");
  },
  getRoutineInspectionsSubmission: function getRoutineInspectionsSubmission(project, date) {
    var templateSlug = this.getRoutineInspectionsTemplate(project);
    return this.getIntervalSubmission(templateSlug, date);
  },
  getBmpInspectionsTemplate: function getBmpInspectionsTemplate() {
    return 'bmp-routine-facility-inspection';
  },
  getRoutineInspectionsTemplate: function getRoutineInspectionsTemplate(project) {
    if (project.bmp_module_enabled && !project.stormwater_enabled) {
      return this.getBmpInspectionsTemplate();
    }

    return project.is_federal ? 'federal-routine-facility-inspection' : "".concat(project.state, "-routine-facility-inspection");
  },
  getDateFromInspectionSlug: function getDateFromInspectionSlug(slug) {
    return this.getDateFromInspectionSlugAsMoment(slug).format();
  },
  getDateFromInspectionSlugAsMoment: function getDateFromInspectionSlugAsMoment(slug) {
    return moment.utc(this._getSubmissionDate(slug), 'YYYY-MM-DD').startOf('day');
  },
  getDateFromInspectionSlugAsDate: function getDateFromInspectionSlugAsDate(slug) {
    return new Date(this._getSubmissionDate(slug));
  },
  _getSubmissionDate: function _getSubmissionDate(slug) {
    var month;

    if (slug.indexOf('ca-visual-assessment') >= 0) {
      if (['3', '4'].includes(slug.slice(-1))) {
        month = '01';
      } else {
        month = '07';
      }

      return "".concat(slug.match(/\d{4}/)[0], "-").concat(month, "-01");
    }

    var nonUtcDate = new Date(slug.match(/\d{4}-\w{3}-\d{2}/)[0]);
    return "".concat(nonUtcDate.getUTCFullYear(), "-").concat(nonUtcDate.getUTCMonth() + 1, "-").concat(nonUtcDate.getUTCDate());
  },

  /**
   * @param state {String} - A state in the United States
   * @param year {String} - 4-digit year
   * @param quarterNumber {Number} - The quarter number for the year (1, 2, 3 or 4)
   * @returns {string} - a submission slug used to create a form submission
   *   Eg: (ca-construction-quarterly-nswd-observation-2015-q1)
   */
  getConstructionQuarterlyObservationsSubmission: function getConstructionQuarterlyObservationsSubmission(state, year, quarterNumber) {
    if (quarterNumber < 1 || quarterNumber > 4) {
      throw new Error('quarterNumber must be between 1 and 4.');
    }

    var formTemplateSlug = this.getConstructionQuarterlyObservationsTemplate(state);
    return [formTemplateSlug, year, "q".concat(quarterNumber)].join('-');
  },

  /**
   * @param state {String} - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionQuarterlyObservationsTemplate: function getConstructionQuarterlyObservationsTemplate(state) {
    return "".concat(state, "-construction-quarterly-nswd-observations");
  },

  /**
   * @param state {String} - A state in the United States
   * @param year {String} - 4-digit year
   * @param weekNumber {Number} - The week number for the year [1-53]
   * @returns {string} - a submission slug used to create a form submission
   *   Eg: (ca-construction-weekly-bmps-observation-2015-w1)
   */
  getConstructionWeeklyObservationsSubmission: function getConstructionWeeklyObservationsSubmission(state, year, weekNumber) {
    if (weekNumber < 1 || weekNumber > 53) {
      throw new Error('weekNumber must be between 1 and 53.');
    }

    var formTemplateSlug = this.getConstructionWeeklyObservationsTemplate(state);
    return [formTemplateSlug, year, "w".concat(weekNumber)].join('-');
  },

  /**
   * @param state {String} - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionWeeklyObservationsTemplate: function getConstructionWeeklyObservationsTemplate(state) {
    return "".concat(state, "-construction-weekly-bmps-observations");
  },

  /**
   * @returns {string} - a form template slug used to identify a form template
   */
  getBozemanConstructionRoutineObservationsTemplate: function getBozemanConstructionRoutineObservationsTemplate() {
    return 'mt-bozeman-construction-routine-inspection';
  },

  /**
   * @param date {Moment}
   * @returns {string} - a submission slug used to create a form submission
   */
  getBozemenaRoutineObservationsSubmission: function getBozemenaRoutineObservationsSubmission(date) {
    var formTemplateSlug = this.getBozemanConstructionRoutineObservationsTemplate();
    var formatted = date.format('YYYY-MMM-DD');
    return [formTemplateSlug, formatted].join('-');
  },
  getBozemanConstructionCityInspectionTemplate: function getBozemanConstructionCityInspectionTemplate() {
    return 'mt-bozeman-construction-city-inspection';
  },

  /**
   * @param state {String} - A state in the United States
   * @param year {String} - 4-digit year
   * @param eventNumber {number} - The event number this form belongs
   *        to - should belong to a "reap-pre-daily-post" set
   * @returns {string} - a submission slug used to create a form submission
   */
  getConstructionPreQreSubmission: function getConstructionPreQreSubmission(state, year, eventNumber) {
    var formTemplateSlug = this.getConstructionPreQreTemplate(state);
    return [formTemplateSlug, year, 'event', eventNumber].join('-');
  },

  /**
   * @param {string} state - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionPreQreTemplate: function getConstructionPreQreTemplate(state) {
    return "".concat(state, "-construction-observations-pre-qre");
  },

  /**
   * @param state {string} - A state in the United States
   * @param year {string} - 4-digit year
   * @param eventNumber {number} - The event number this form belongs
   *        to - should belong to a "reap-pre-daily-post" set
   * @returns {string} - a submission slug used to create a form submission
   */
  getConstructionDailyQreSubmission: function getConstructionDailyQreSubmission(state, year, eventNumber, dayNumber) {
    var formTemplateSlug = this.getConstructionDailyQreTemplate(state);
    return [formTemplateSlug, year, 'event', eventNumber, 'day', dayNumber].join('-');
  },

  /**
   * @param dailyQreSubmissionSlug {String} - A submission slug used
   *        to identify daily QRE submissions
   * @returns {number} - The day number of the rain event
   */
  getDayNumberFromConstructionDailyQreSubmission: function getDayNumberFromConstructionDailyQreSubmission(dailyQreSubmissionSlug) {
    var matches = dailyQreSubmissionSlug.match(/day-(\d+)/);
    return +(matches && matches[1]) || undefined;
  },

  /**
   * @param state {String} - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionDailyQreTemplate: function getConstructionDailyQreTemplate(state) {
    return "".concat(state, "-construction-observations-daily-qre");
  },

  /**
   * @param state {String} - A state in the United States
   * @param year {String} - 4-digit year
   * @param eventNumber {Number} - The event number this form belongs
   *        to - should belong to a "reap-pre-daily-post" set
   * @returns {string} - a submission slug used to create a form submission
   */
  getConstructionPostQreSubmission: function getConstructionPostQreSubmission(state, year, eventNumber) {
    var formTemplateSlug = this.getConstructionPostQreTemplate(state);
    return [formTemplateSlug, year, 'event', eventNumber].join('-');
  },

  /**
   * @param state {String} - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionPostQreTemplate: function getConstructionPostQreTemplate(state) {
    return "".concat(state, "-construction-observations-post-qre");
  },

  /**
   * @param state {String} - A state in the United States
   * @param year {String} - 4-digit year
   * @param eventNumber {Number} - The event number this form belongs
   *        to - should belong to a "reap-pre-daily-post" set
   * @returns {string} - a submission slug used to create a form submission
   */
  getConstructionReapSubmission: function getConstructionReapSubmission(state, year, eventNumber) {
    var formTemplateSlug = this.getConstructionReapTemplate(state);
    return [formTemplateSlug, year, 'event', eventNumber].join('-');
  },

  /**
   * @param state {String} - A state in the United States
   * @returns {string} - a form template slug used to identify a form template
   */
  getConstructionReapTemplate: function getConstructionReapTemplate(state) {
    return "".concat(state, "-construction-reap");
  },

  /**
   * @param qreSubmissionSlug {String} - A submission slug used to
   *        identify any type of QRE submission
   * @returns {number} - The rain event number
   */
  getEventNumberFromConstructionQreSubmission: function getEventNumberFromConstructionQreSubmission(qreSubmissionSlug) {
    var matches = qreSubmissionSlug.match(/event-(\d+)/);
    return +(matches && matches[1]) || undefined;
  },
  getGeneralSiteInspectionsTemplate: function getGeneralSiteInspectionsTemplate() {
    return 'federal-general-inspection-form';
  },
  getSpccRegularInspectionsSubmission: function getSpccRegularInspectionsSubmission(industryType, date) {
    var templateSlug = this.getSpccRegularInspectionsTemplate(industryType);
    return this.getIntervalSubmission(templateSlug, date);
  },
  getSP001SpccInspectionsTemplate: function getSP001SpccInspectionsTemplate() {
    return 'federal-industrial-sp001-spcc-inspection';
  },
  getSpccRegularInspectionsTemplate: function getSpccRegularInspectionsTemplate(industryType) {
    return ['federal', industryType, 'spcc-regular-inspection'].join('-');
  },
  getSpccFrequentInspectionsSubmission: function getSpccFrequentInspectionsSubmission(industryType, date) {
    var templateSlug = this.getSpccFrequentInspectionsTemplate(industryType);
    return this.getIntervalSubmission(templateSlug, date);
  },
  getSpccFrequentInspectionsTemplate: function getSpccFrequentInspectionsTemplate(industryType) {
    return ['federal', industryType, 'spcc-frequent-inspection'].join('-');
  },
  getHmbpRegularInspectionsTemplate: function getHmbpRegularInspectionsTemplate() {
    return 'federal-hmbp-regular-hazardous-accumulation-storage-inspection';
  },
  getHmbpRegularTankInspectionsTemplate: function getHmbpRegularTankInspectionsTemplate() {
    return 'federal-hmbp-regular-tank-inspection';
  },
  getAsNeededInspectionsSubmission: getAsNeededInspectionsSubmission,
  getSpccAsNeededInspectionsSubmission: function getSpccAsNeededInspectionsSubmission(industryType, year, asNeededNumber) {
    var templateSlug = this.getSpccAsNeededInspectionsTemplate(industryType);
    return getAsNeededInspectionsSubmission(templateSlug, year, asNeededNumber);
  },
  getBozemanAsNeededInspectionsSubmission: function getBozemanAsNeededInspectionsSubmission(date) {
    var templateSlug = this.getBozemanConstructionCityInspectionTemplate();
    var formatted = date.format('YYYY-MMM-DD');
    return [templateSlug, formatted].join('-');
  },
  getSpccAsNeededInspectionsTemplate: function getSpccAsNeededInspectionsTemplate(industryType) {
    return ['federal', industryType, 'spcc-as-needed-inspection'].join('-');
  },
  getFireExtinguisherInspectionsTemplate: function getFireExtinguisherInspectionsTemplate() {
    return 'federal-fire-extinguisher';
  },
  getTrackOutTemplate: function getTrackOutTemplate() {
    return 'federal-track-out-inspection';
  },
  getVisualEmissionsTemplate: function getVisualEmissionsTemplate() {
    return 'federal-visual-air-emissions-inspection';
  },
  getNumberFromAsNeededInspectionSlug: function getNumberFromAsNeededInspectionSlug(slug) {
    var match = slug.match(/\d+$/);
    return parseFloat(match && match[0]);
  },
  getIntervalSubmission: function getIntervalSubmission(templateSlug, date) {
    var d = moment(date, moment.ISO_8601);
    return this.getIntervalSubmissionFromMoment(templateSlug, d);
  },
  getIntervalSubmissionFromMoment: function getIntervalSubmissionFromMoment(templateSlug, d) {
    return [templateSlug, d.format('YYYY'), d.format('MMM').toLowerCase(), d.format('DD')].join('-');
  },
  getIntervalSubmissionFromNativeDate: function getIntervalSubmissionFromNativeDate(templateSlug, d) {
    return [templateSlug, d.getUTCFullYear(), MapistryDate.getShortMonthName(d).toLowerCase(), MapistryDate.getTwoCharDate(d)].join('-');
  },
  getIntervalSubmissionForTwiceWeekly: function getIntervalSubmissionForTwiceWeekly(templateSlug, d, submissionNumber) {
    return [templateSlug, submissionNumber, d.getUTCFullYear(), MapistryDate.getShortMonthName(d).toLowerCase(), MapistryDate.getTwoCharDate(d)].join('-');
  },
  getAnnualEvalTemplate: function getAnnualEvalTemplate(projectIsFederal, swpppYear, state) {
    if (projectIsFederal) {
      return 'federal-annual-eval';
    }

    if (swpppYear < 2017 && state === 'ca') {
      return 'ca-acfce';
    }

    return "".concat(state, "-acfce-2018");
  },
  getAnnualEvalSubmission: function getAnnualEvalSubmission(projectIsFederal, swpppYear, state) {
    return "".concat(this.getAnnualEvalTemplate(projectIsFederal, swpppYear, state), "-").concat(swpppYear);
  },
  getCALevel1ExceedanceTemplate: function getCALevel1ExceedanceTemplate(projectIsFederal, projectState) {
    return projectIsFederal ? 'federal-level-1' : "".concat(projectState, "-level-1");
  },
  getCALevel1ExceedanceSubmission: function getCALevel1ExceedanceSubmission(projectIsFederal, projectState, swpppYear) {
    return "".concat(this.getCALevel1ExceedanceTemplate(projectIsFederal, projectState), "-").concat(swpppYear);
  }
};
var _default = SlugFactory;
exports["default"] = _default;